import styled from 'styled-components';
import { motion } from 'framer-motion';

export const ButtonWrapper = styled(motion.div)`
    //margin-top: 32px;
    display: flex;
    // flex-direction: column;
    align-items: center;
`